import React, { useContext, useState } from "react";
import { Modal, Button, Form, Select, message, Space } from "antd";
import { FaTruck, FaWarehouse, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { HomeContext } from "./HomeContext";
import { createShipment, getShipments, assignDriverToShipment } from "../../services/shipmentService";

const { Option } = Select;


const MultipleOrdersAssign = () => {
    const { multipleModalOpen, setMultipleModalOpen, driverData, wareHouseData, awaitingOrders,
        getOrders, getAssignOrders, selectedRowKeys, setSelectedRowKeys, orders, userDetail
    }: any = useContext(HomeContext);

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false); // Track API call status

    // Handle Order Assignment via Shipments (Phase 9)
    const handleAssignOrders = async () => {
        form.validateFields()
            .then(async values => {
                if (selectedRowKeys?.length === 0) {
                    message.error("Please select at least one order.");
                    return;
                }
                setLoading(true);
                try {
                    const results = await Promise.allSettled(
                        selectedRowKeys.map(async (orderId: any) => {
                            const shipmentsRes = await getShipments({ orderId });
                            const existingShipments = shipmentsRes?.data || [];
                            if (existingShipments.length > 0) {
                                return assignDriverToShipment(existingShipments[0].id, values.driver);
                            }
                            const order = orders?.find((o: any) => o.id === orderId) || awaitingOrders?.find((o: any) => o.id === orderId);
                            return createShipment({
                                orderId,
                                storeId: order?.store_id || userDetail?.storeId,
                                driverId: values.driver,
                                pickupWarehouseId: values.warehouse,
                            });
                        })
                    );
                    const failed = results.filter(r => r.status === "rejected" || (r.status === "fulfilled" && !r.value?.data && !r.value?.message));
                    if (failed.length) {
                        message.warning(`${failed.length} orders failed to be assigned.`);
                    } else {
                        message.success("All selected orders assigned successfully!");
                        setMultipleModalOpen(false);
                        setSelectedRowKeys([]);
                    }
                    getOrders?.();
                    getAssignOrders?.();
                } catch (error: any) {
                    message.error(error?.message || "Something went wrong. Please try again.");
                } finally {
                    setLoading(false);
                }
            })
            .catch(() => {});
    };

    return (
        <Modal
            title={
                <Space>
                    <FaCheckCircle style={{ color: '#1890ff' }} />
                    <span>Assign Orders</span>
                </Space>
            }
            open={multipleModalOpen}
            onCancel={() => setMultipleModalOpen(false)}
            footer={[
                <Button key="cancel" danger onClick={() => setMultipleModalOpen(false)}>
                    <Space>
                        <FaTimesCircle /> Cancel
                    </Space>
                </Button>,
                <Button loading={loading} key="assign" type="primary" onClick={handleAssignOrders}>
                    <Space>
                        <FaCheckCircle /> Assign Orders
                    </Space>
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                {/* Driver Selection */}
                <Form.Item
                    name="driver"
                    label={
                        <Space>
                            <FaTruck /> <strong>Select Driver:</strong>
                        </Space>
                    }
                        rules={[{ required: true, message: "Please select a driver!" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Search and select a driver"
                            optionFilterProp="children"
                        >
                            {driverData.map((driver) => (
                                <Option key={driver.id} value={driver.id}>
                                    <Space>
                                        {driver.photoData?.url ? (
                                            <img
                                                src={driver.photoData?.url}
                                                alt={driver.firstName}
                                                style={{ borderRadius: '50%', marginRight: 8 }}
                                                width="25"
                                                height="25"
                                            />
                                        ) : (
                                            <img
                                                src={"/image/user.png"}
                                                alt={driver.firstName}
                                                style={{ borderRadius: '50%', marginRight: 8 }}
                                                width="25"
                                                height="25"
                                            />
                                        )}
                                        {driver.firstName} {driver.lastName} - {driver.vehicle_number}
                                    </Space>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {/* Warehouse Selection */}
                    <Form.Item
                        name="warehouse"
                        label={
                            <Space>
                                <FaWarehouse /> <strong>Select Warehouse:</strong>
                            </Space>
                        }
                        rules={[{ required: true, message: "Please select a warehouse!" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Search and select a warehouse"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {wareHouseData.map((wh: any) => (
                                <Option key={wh.id} value={wh.id}>
                                    {wh.name} - {wh.address}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                </Form>
        </Modal>
    );
};

export default MultipleOrdersAssign;
